import { Container, Row, Col } from 'react-bootstrap';
import 'styles/profile-image.scss';
import TimeLine from './TimeLine';

const social_buttons = [
    {
        svg: (
            <svg
                className='social-media-icons__twitter'
                xmlns='http://www.w3.org/2000/svg'
                x='0px'
                y='0px'
                width='40'
                height='40'
                viewBox='0 0 50 50'
            >
                <path d='M25,2C12.317,2,2,12.317,2,25s10.317,23,23,23s23-10.317,23-23S37.683,2,25,2z M36.237,20.524 c0.01,0.236,0.016,0.476,0.016,0.717C36.253,28.559,30.68,37,20.491,37c-3.128,0-6.041-0.917-8.491-2.489 c0.433,0.052,0.872,0.077,1.321,0.077c2.596,0,4.985-0.884,6.879-2.37c-2.424-0.044-4.468-1.649-5.175-3.847 c0.339,0.065,0.686,0.1,1.044,0.1c0.505,0,0.995-0.067,1.458-0.195c-2.532-0.511-4.441-2.747-4.441-5.432c0-0.024,0-0.047,0-0.07 c0.747,0.415,1.6,0.665,2.509,0.694c-1.488-0.995-2.464-2.689-2.464-4.611c0-1.015,0.272-1.966,0.749-2.786 c2.733,3.351,6.815,5.556,11.418,5.788c-0.095-0.406-0.145-0.828-0.145-1.262c0-3.059,2.48-5.539,5.54-5.539 c1.593,0,3.032,0.672,4.042,1.749c1.261-0.248,2.448-0.709,3.518-1.343c-0.413,1.292-1.292,2.378-2.437,3.064 c1.122-0.136,2.188-0.432,3.183-0.873C38.257,18.766,37.318,19.743,36.237,20.524z'></path>
            </svg>
        ),
        link: 'https://twitter.com/chr_jim',
    },
    {
        svg: (
            <svg
                className='social-media-icons__facebook'
                xmlns='http://www.w3.org/2000/svg'
                x='0px'
                y='0px'
                width='40'
                height='40'
                viewBox='0 0 48 48'
            >
                <path d='M24 5A19 19 0 1 0 24 43A19 19 0 1 0 24 5Z'></path>
                <path
                    fill='#242424'
                    d='M26.572,29.036h4.917l0.772-4.995h-5.69v-2.73c0-2.075,0.678-3.915,2.619-3.915h3.119v-4.359c-0.548-0.074-1.707-0.236-3.897-0.236c-4.573,0-7.254,2.415-7.254,7.917v3.323h-4.701v4.995h4.701v13.729C22.089,42.905,23.032,43,24,43c0.875,0,1.729-0.08,2.572-0.194V29.036z'
                ></path>
            </svg>
        ),
        link: 'https://www.facebook.com/profile.php?id=100002975871867',
    },

    {
        svg: (
            <svg
                className='social-media-icons__github'
                xmlns='http://www.w3.org/2000/svg'
                x='0px'
                y='0px'
                width='40'
                height='40'
                viewBox='0 0 24 24'
            >
                {' '}
                <path d='M10.9,2.1c-4.6,0.5-8.3,4.2-8.8,8.7c-0.5,4.7,2.2,8.9,6.3,10.5C8.7,21.4,9,21.2,9,20.8v-1.6c0,0-0.4,0.1-0.9,0.1 c-1.4,0-2-1.2-2.1-1.9c-0.1-0.4-0.3-0.7-0.6-1C5.1,16.3,5,16.3,5,16.2C5,16,5.3,16,5.4,16c0.6,0,1.1,0.7,1.3,1c0.5,0.8,1.1,1,1.4,1 c0.4,0,0.7-0.1,0.9-0.2c0.1-0.7,0.4-1.4,1-1.8c-2.3-0.5-4-1.8-4-4c0-1.1,0.5-2.2,1.2-3C7.1,8.8,7,8.3,7,7.6c0-0.4,0-0.9,0.2-1.3 C7.2,6.1,7.4,6,7.5,6c0,0,0.1,0,0.1,0C8.1,6.1,9.1,6.4,10,7.3C10.6,7.1,11.3,7,12,7s1.4,0.1,2,0.3c0.9-0.9,2-1.2,2.5-1.3 c0,0,0.1,0,0.1,0c0.2,0,0.3,0.1,0.4,0.3C17,6.7,17,7.2,17,7.6c0,0.8-0.1,1.2-0.2,1.4c0.7,0.8,1.2,1.8,1.2,3c0,2.2-1.7,3.5-4,4 c0.6,0.5,1,1.4,1,2.3v2.6c0,0.3,0.3,0.6,0.7,0.5c3.7-1.5,6.3-5.1,6.3-9.3C22,6.1,16.9,1.4,10.9,2.1z'></path>
            </svg>
        ),
        link: 'https://github.com/JimChr-R4GN4R',
    },
    {
        svg: (
            <svg
                className='social-media-icons__linkedin'
                xmlns='http://www.w3.org/2000/svg'
                x='0px'
                y='0px'
                width='40'
                height='40'
                viewBox='0 0 48 48'
            >
                <path d='M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z'></path>
                <path
                    fill='#242424'
                    d='M14 19H18V34H14zM15.988 17h-.022C14.772 17 14 16.11 14 14.999 14 13.864 14.796 13 16.011 13c1.217 0 1.966.864 1.989 1.999C18 16.11 17.228 17 15.988 17zM35 24.5c0-3.038-2.462-5.5-5.5-5.5-1.862 0-3.505.928-4.5 2.344V19h-4v15h4v-8c0-1.657 1.343-3 3-3s3 1.343 3 3v8h4C35 34 35 24.921 35 24.5z'
                ></path>
            </svg>
        ),
        link: 'https://www.linkedin.com/in/dimitris-chrysoheris-8bba1520a/',
    },
];

function ProfileImage({link}: any) {
    return (
        <img
            src={link}
            alt='profile'
            className='round-profile-image no-select'
        />
    );
}

function ProfileName(props: any) {
    return (
        <h1
            style={{
                // width: 'fit-content',
                textAlign: 'center',
            }}
            className='text'
        >
            {props.children}
        </h1>
    );
}

function FooterSocialMediaButtons() {
    return (
        <Row className='justify-content-center mb-1'>
            {
                social_buttons.map((button) => {
                    return (
                        <Col
                            key={button.link}
                            xs='auto'
                            sm='auto'
                            md='auto'
                            lg='auto'
                            xl='auto'
                            xxl='auto'
                        >
                            <a
                                href={button.link}
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                {button.svg}
                            </a>
                        </Col>
                    );
                })
            }
            {/* {Object.keys(social_buttons).map((key) => {
                return (
                    <Col
                        key={key}
                        xs='auto'
                        sm='auto'
                        md='auto'
                        lg='auto'
                        xl='auto'
                        xxl='auto'
                    >
                        <a
                            href={
                                social_buttons[
                                    key as keyof typeof social_buttons
                                ].link
                            }
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            {
                                social_buttons[
                                    key as keyof typeof social_buttons
                                ].svg
                            }
                        </a>
                    </Col>
                );
            })} */}
        </Row>
    );
}

export default function Profile({ data }: any) {
    return (
        <Container>
            <Row className='justify-content-center'>
                <ProfileImage link={data.profile} />
            </Row>
            <Row className='mb-2'>
                <Container
                    style={{ width: '300px' }}
                    className='glass pt-1 social-media-icons profile-image-footer'
                >
                    <div style={{ height: '80px' }}></div>
                    <Row className='justify-content-center'>
                        <FooterSocialMediaButtons />
                    </Row>
                </Container>
            </Row>
            <Row className='justify-content-center'>
                <ProfileName>Dimitris Chrysoheris</ProfileName>
            </Row>
            <Container fluid>
                <TimeLine events={data.events} />
            </Container>
        </Container>
    );
}
